<template>
  <v-card flat>
    <v-card-text>
      <template v-if="value.change_rich_menu_status">
        <v-layout wrap :style="{ margin: '-4px' }">
          <v-flex xs12 class="pa-1">
            {{ value.rich_menu_id }}
          </v-flex>
          <v-flex xs12 class="pa-1">
            <img
              v-if="selected"
              :src="selected.rich_menu_image_url"
              alt="Image"
              :style="{ display: 'block', width: '100%', maxWidth: '480px' }"
            />
          </v-flex>
        </v-layout>
      </template>
      <template v-else>-</template>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import lineRichMenuApi from '@/api/line-rich-menu'

export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      items: []
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    selected() {
      return this.items.find((item) => item.rich_menu_id === this.value.rich_menu_id)
    }
  },
  created() {
    if (this.value.change_rich_menu_status) {
      this.fetch()
    }
  },
  methods: {
    async fetch() {
      try {
        const response = await lineRichMenuApi.getItems(this.selectedBot.pageid, {
          limit: 1000,
          offset: 0,
          published: true
        })
        if (response.status !== 200) return
        const { data } = response.data
        this.items = data
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/intent/RichMenu.vue